module.exports = __webpack_public_path__ + "img/jisukuaile_icon.ed16054f.png";